/** O atalho `N` para criar oportunidade (SPEC-FE-003).
 *
 * O teclado é sensor de primeira classe neste produto, não acréscimo
 * (ADR-0016). O board inteiro é operável sem mouse — arrastar card inclusive —
 * e a criação era a única ação frequente que exigia mirar num botão.
 *
 * A regra difícil não é ouvir a tecla: é **saber quando não ouvir**. Uma letra
 * solta como atalho global rouba a digitação de quem está escrevendo, e o
 * board tem campo de busca no próprio cabeçalho — digitar "Novos" ali abriria
 * o formulário na primeira letra e comeria o resto.
 */

/** Se a tecla deve abrir a criação.
 *
 * Função pura e exportada de propósito: é a parte que erra, e testá-la pelo
 * DOM exigiria montar a tela inteira para cada caso.
 */
export function abreCriacao(evento: KeyboardEvent): boolean {
  if (evento.key !== "n" && evento.key !== "N") return false;

  // Com modificador é outro comando — `Ctrl+N` abre janela no navegador, e
  // interceptá-lo seria tomar da pessoa um atalho que não é nosso.
  if (evento.ctrlKey || evento.metaKey || evento.altKey) return false;

  // Já tratado por outra coisa (um menu aberto, um diálogo). Repetir aqui
  // dispararia duas ações com um toque.
  if (evento.defaultPrevented) return false;

  return !estaDigitando(evento.target);
}

/** Se o foco está num lugar onde uma letra é texto, e não comando. */
function estaDigitando(alvo: EventTarget | null): boolean {
  if (!(alvo instanceof HTMLElement)) return false;

  // `isContentEditable` cobre editor rico; a etiqueta cobre os campos comuns.
  // `select` entra na lista porque nele as letras saltam para a opção — um
  // atalho aqui roubaria a navegação por digitação.
  if (alvo.isContentEditable) return true;

  return ["INPUT", "TEXTAREA", "SELECT"].includes(alvo.tagName);
}

/** O nome do evento que pede a criação de fora do board.
 *
 * A navegação inferior do celular tem um botão "+" central, e o formulário é
 * estado interno do `QuadroDeOportunidades`. Um evento no `window` liga os dois
 * sem que a moldura do aplicativo precise saber como o board se organiza por
 * dentro — nem o board, quem o chamou.
 *
 * O mesmo caminho do atalho `N`, e de propósito: duas portas para a mesma ação
 * que divergissem produziriam dois formulários diferentes com o tempo.
 */
export const EVENTO_DE_CRIACAO = "tanzuh:criar-oportunidade";

export function pedirCriacao(): void {
  window.dispatchEvent(new CustomEvent(EVENTO_DE_CRIACAO));
}
